import { Grid, makeStyles, Typography } from "@material-ui/core";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { SendToBillingStore as Store } from "store";
import { formatNumberToMonetary } from "utils";

const useStyles = makeStyles({
  summaryText: {
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    textTransform: "uppercase",

    "&.label": {
      width: 100,
    },

    "&.invalid": {
      color: "#D73912",
    },

    "&.valid": {
      color: "#0E8755",
    },
  },
});

/** Componente com sumário dos valores de saldo e valor total a serem enviados para faturamento. */
const ProductItemsSummary = observer(() => {
  const classes = useStyles();

  const balanceMeasured = Store.getProductsBalanceOfTotalMeasured();
  const status = balanceMeasured === 0 ? "valid" : "invalid";

  return (
    <Grid
      container
      justifyContent="flex-start"
      direction="column"
      className="mt-1"
    >
      <Grid container item>
        <Typography className={`${classes.summaryText} label ${status}`}>
          {`${lang("fields.balance")}:`}
        </Typography>
        <Typography className={`${classes.summaryText} ${status}`}>
          {formatNumberToMonetary(balanceMeasured)}
        </Typography>
      </Grid>
      <Grid container item>
        <Typography className={`${classes.summaryText} label`}>
          {`${lang("fields.totalValue")}:`}
        </Typography>
        <Typography className={`${classes.summaryText}`}>
          {formatNumberToMonetary(Store.totalMeasured)}
        </Typography>
      </Grid>
    </Grid>
  );
});

export default ProductItemsSummary;
